import React from 'react'
import {Form, Row, Col} from 'react-bootstrap'
import CustomSelect from '../formikControl/advancedSelect/Custom'
import {FilterField} from './types'

type FilterFormProps = {
  fields: FilterField[]
  filters: Record<string, string>
  onChange: (name: string, value: string) => void
  colProps?: Record<string, any> | (Record<string, any> | undefined)[]
}

const FilterForm: React.FC<FilterFormProps> = ({fields, filters, onChange, colProps}) => (
  <Row>
    {fields.map((field, index) => (
      <Col key={field.name} {...(Array.isArray(colProps) ? colProps[index] : colProps)}>
        <Form.Group className="mb-3" controlId={`filter-${field.name}`}>
          <Form.Label className="text-gray-600 fw-normal mb-1">{field.label}</Form.Label>
          <CustomSelect
            size="xs"
            isClearable
            isSearchable
            onChange={(selected: any) => {
              onChange(field.name, selected?.[field.optionValue] || '')
            }}
            getOptionValue={(option: any) => option[field.optionValue]}
            options={field.options || []}
            name={field.name}
            getOptionLabel={(option: any) => option[field.optionLabel]}
            value={
              field.options?.find((option) => option[field.optionValue] === filters[field.name]) ||
              null
            }
            {...field.selectProps}
          />
        </Form.Group>
      </Col>
    ))}
  </Row>
)

export default FilterForm
